import Vue from 'vue';
import Vuelidate from 'vuelidate';
import Notifications from 'vue-notification';
import App from './App.vue';
import router from '@/router';
import store from '@/store';

Vue.config.productionTip = false;

import vuetify from '@/plugins/vuetify';

import 'vuetify/dist/vuetify.min.css';

Vue.use(Vuelidate);
Vue.use(Notifications)

export default new Vue({
    store,
    vuetify,
    router,
    render: h => h(App)
}).$mount('#app');
